import { Component, Input, OnInit } from '@angular/core';
import { TransactionDetails } from 'src/app/shared/interfaces/User';

@Component({
  selector: 'app-user-payment-details',
  templateUrl: './user-payment-details.component.html',
  styleUrls: ['./user-payment-details.component.scss'],
})
export class UserPaymentDetailsComponent implements OnInit {
  @Input() details: TransactionDetails | null | undefined;

  paymentDetails: any;
  merchant_name?: string;
  reference?: string;
  amount?: string;

  constructor() {}

  ngOnInit(): void {
    const details = this.details;
    this.paymentDetails = details?.transaction_object;
    if (details?.type === 'ORDER_PAYMENT') {
      this.merchant_name = this.paymentDetails?.order?.merchant?.name;
      this.reference = this.paymentDetails?.transaction?.purpl_reference;
      this.amount = this.paymentDetails?.amount?.value;
    } else {
      this.merchant_name = this.paymentDetails?.merchant_name;
      this.reference = this.paymentDetails?.partner_reference;
      this.amount = this.paymentDetails?.amount;
    }
  }
}
